import 'devextreme/dist/css/dx.common.css';
import './themes/app-theme.css';
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import './dx-styles.scss';
import LoadPanel from 'devextreme-react/load-panel';
import { NavigationProvider } from './contexts/navigation';
import { AuthProvider, useAuth } from './contexts/auth';
import { ThemeProvider } from './contexts/theme';
import { useScreenSizeClass } from './utils/media-query';
import Content from './Content';
import UnauthenticatedContent from './UnauthenticatedContent';
import { TenancySelection } from './components';
import config from 'devextreme/core/config';
import { licenseKey } from './devexpress-license';

config({ licenseKey });

function App() {
  const { user, loading, pendingSelection } = useAuth();

  if (loading) {
    return <LoadPanel visible={true} />;
  }

  if (pendingSelection) {
    return <TenancySelection />;
  }

  if (user) {
    return <Content />;
  }

  return <UnauthenticatedContent />;
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass();

  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}  signUp_page`}>
              <App />
            </div>
          </NavigationProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}
